import React from "react";

import Background from "../../../assets/lunch/lunch-select.png";
import ImageA from "../../../assets/lunch/lunch-option-a.png";
import ImageB from "../../../assets/lunch/lunch-option-b.png";

import GameSelectionLayout from "../GameSelectionLayout";

const LunchPage3 = ({ setCurrentPage, setGarbageQtty }) => {
  const handleClickA = () => {
    setCurrentPage("lunch-4");
  };

  const handleClickB = () => {
    setGarbageQtty((prev) => prev + 8);
    setCurrentPage("lunch-5");
  };

  return (
    <GameSelectionLayout
      bg={Background}
      imageA={ImageA}
      textA="도시락"
      onClickA={handleClickA}
      imageB={ImageB}
      textB="배달음식"
      onClickB={handleClickB}
      currentIndex={1}
    >
      도시락 싸오긴 했는데.
      <br />
      중국집 배달음식이면 나무젓가락에
      <br />
      단무지 그릇도 1회용이겠지.
      <br />
      그치만 먹고 싶다 짜장면...
    </GameSelectionLayout>
  );
};

export default LunchPage3;
